import styled from 'styled-components';

import { position } from '../../core';

const ResponsiveVideoStyled = styled.div.attrs({
  className: 'component__ResponsiveVideo',
})`
  padding: 56.25% 0 0 0;
  position: relative;
  iframe, video {
    width: 100%;
    height: 100%;
    ${position('absolute', '0', '', '', '0')};
  }
`;

export default ResponsiveVideoStyled;
